module.exports = __webpack_public_path__ + "img/terroir-redshift-4-mobile.9f8c1143.jpg";